import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography
} from "@material-ui/core";
import { Formik } from "formik";
import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import SpinnerButton from "../../../../components/buttons/SpinnerButton";
import {
  DialogActions,
  DialogTitle,
  Dialog,
  DialogContent
} from "../../../../components/Dialog";
import API from "../../../../api";
import { openSnackbar } from "../../../../modules/ui";
import BoldInput from "../../../../components/inputs/BoldInput";

function AddBulkFRNotes({ handleClose, show, selected }) {
  const dispatch = useDispatch();
  const onSubmit = useCallback(
    async (values, actions) => {
      try {
        actions.setSubmitting(true);
        await API.factoring.BulkFundingRequestNotes(
          selected,
          values.internalTransactionNotes,
          values.noteMode
        );
        dispatch(openSnackbar("success", "Note has been added."));
      } catch (e) {
        dispatch(openSnackbar("error", "Error while adding note."));
      }
      actions.setSubmitting(false);
    },
    [selected]
  );

  return (
    <Formik
      initialValues={{
        internalTransactionNotes: "",
        noteMode: "internal_only"
      }}
      onSubmit={onSubmit}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        values,
        touched,
        errors,
        setFieldValue
      }) => (
        <Dialog
          onClose={handleClose}
          open={show}
          fullWidth
          maxWidth="sm"
          scroll="body"
        >
          <DialogTitle onClose={handleClose}>
            New Funding Request Note
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              direction="column"
              spacing={16}
              style={{ minHeight: 150 }}
            >
              <Grid item>
                <Typography
                  variant="subtitle2"
                  style={{ fontWeight: 700, marginBottom: 4 }}
                >
                  Note Mode
                </Typography>
                <RadioGroup
                  name="noteMode"
                  value={values.noteMode}
                  onChange={e => setFieldValue("noteMode", e.target.value)}
                >
                  <FormControlLabel
                    value="internal_only"
                    control={<Radio color="primary" />}
                    label="Internal Notes Only"
                  />
                  <FormControlLabel
                    value="internal_and_status"
                    control={<Radio color="primary" />}
                    label="Internal Notes + Status Notes"
                  />
                </RadioGroup>
              </Grid>
              <Grid item>
                <BoldInput
                  fullWidth
                  name="internalTransactionNotes"
                  label={"Internal Transaction Notes" + (values.noteMode === "internal_and_status" ? " (also written to Status Notes)" : "")}
                  rows="4"
                  multiline
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.internalTransactionNotes}
                  error={
                    touched.internalTransactionNotes &&
                    !!errors.internalTransactionNotes
                  }
                  helperText={
                    touched.internalTransactionNotes
                      ? errors.internalTransactionNotes
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <SpinnerButton
              variant="outlined"
              size="small"
              color="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              Submit
            </SpinnerButton>
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
}
export default AddBulkFRNotes;
